// libs
import React from 'react';
// dls
import { BaseTheme } from '@swiggy-private/dls-web-common/dist/components/themes/Base';
import { FontStyle } from '@swiggy-private/dls-web-theme/dist/components/Fonts';
import { ThemeProvider } from '@swiggy-private/dls-web-theme/dist/components/ThemeProvider';
const CoreLayout = ({ children }) => {
    return (React.createElement(ThemeProvider, { theme: BaseTheme, color: "light" },
        React.createElement(FontStyle, null),
        children));
};
export default CoreLayout;
